<div class="search-dd">
  <div class="searchContainer">
    <input
      #searchBox
      class="searchBox"
      autocomplete="no-autofill"
      [formControl]="searchControl"
      type="search"
      placeholder="Search Property"
    />
    <mat-icon class="search">search</mat-icon>
  </div>
  <div class="searchResults">
    <ul>
      <ng-container *ngFor="let record of textSearch | async">
        <li
          *ngFor="let usage of record.usages"
          (click)="addRecord(usage.id)"
          matTooltip="Add this Record to the Property Set"
          matTooltipPosition="below"
        >
          <div>
            {{ record.property_name ? record.property_name + ' | ' : '' }} {{ record.postal_address.full_street_name }}
          </div>
          <div>
            {{ usage.ref_property_usage_type_desc | translatePropertyType }}
            <mat-icon *ngIf="usage.statistical_f" class="alpha-s" svgIcon="alphabet-s-icon"></mat-icon
            >{{ ' | ' + usage.lig_geography.market_desc }}
          </div>
        </li>
      </ng-container>
    </ul>
    <span *ngIf="!textSearch && (textSearch | async).length === 0">No records found</span>
  </div>
  <ng-content></ng-content>
</div>
